module.exports = __webpack_public_path__ + "static/img/UTSG老师_Vincent.872d142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_Vincent.png
// module id = gj5V
// module chunks = 0